import React, { } from "react";
import {
    Box,
    useMediaQuery,
    Text,
    useTheme,
} from "@chakra-ui/react";
import { useDirection } from "../../context/DirectionContext";
import { useTranslation } from "react-i18next";
import video from '../../assets/video.mp4'

const Content = () => {
    const [isMobileView] = useMediaQuery("(max-width: 991px)");
    const { direction } = useDirection();
    const { colors } = useTheme();
    const { t } = useTranslation();

    return (
        <Box
            textAlign={"center"}
            position="relative"
            width={isMobileView ? "100%" : "80%"}
            mt={isMobileView ? 5 : 10}
            pt={isMobileView ? 5 : 10}
            opacity={1.0}
            dir={direction === "rtl" ? "rtl" : "ltr"}
        >
            {/* <AspectRatio height={500} position={'relative'} > */}
            <iframe
                style={{ height: 400, position: "relative", width: '100%' }}
                title='selective mutism'
                src={video}
                allowFullScreen
            />
            <Text color={colors.primary[300]} mt={5}>{t("home.videoby")}</Text>
            {/* </AspectRatio> */}
        </Box>
    );
};

export default Content;
